<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
     <div class="row justify-content-center">
   	   <div class=""> 
   	   
   	 
 			
 			
 			
 			
 			 <!-- start -->
   	   	  <div class="col-md-auto" @click="goToCreateRequestNext(901)">
   	   	  <div style="padding:50px 30px 20px 30px;text-align:center;margin-top:120px" class="heading">
   	   	  				Submit a request and we will find you the right expert to assist you.</div>
   	  	   <card  type="info" gradient="info">
			  <div class="row align-items-center">
				<div class="col-auto">			  
				   <div class="icon icon-shape text-white rounded-circle shadow bg-default">
						<i class="fa fa-pencil-alt"></i>
					</div>
				</div>
				<div class="col ml--2">
				  <h4 class="mb-0 text-white">
					Custom Request
				  </h4>

				</div>
				<div class="col-auto">
				  <base-button type="warning" size="sm">+</base-button>
				</div>
			  </div>
			</card>
			</div>
 			<!-- end -->
 			
 			
 			
 
 
 		  </div>
    	</div>
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'

  export default {
    components: {
  
    },
    data() {
      return {
     	 officers:[],
	
      };
    },
    methods: {
      goToCreateRequestNext(type) {
  
				this.$router.push( '/create-request-details/'+type);
      }
    },
    mounted() {

      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














